/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) { if (typeof j != "undefined") { m = m || {}; if (j === null) { j = ""; m.expires = -1 } var e = ""; if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) { var f; if (typeof m.expires == "number") { f = new Date(); f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000)) } else { f = m.expires } e = "; expires=" + f.toUTCString() } var l = m.path ? "; path=" + (m.path) : ""; var g = m.domain ? "; domain=" + (m.domain) : ""; var a = m.secure ? "; secure" : ""; document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("") } else { var d = null; if (document.cookie && document.cookie != "") { var k = document.cookie.split(";"); for (var h = 0; h < k.length; h++) { var c = jQuery.trim(k[h]); if (c.substring(0, b.length + 1) == (b + "=")) { d = decodeURIComponent(c.substring(b.length + 1)); break } } } return d } };

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * ANB: Rewritten doAlong to fire parallel AJAX requests instead of sequential,
 * reducing load time from (n * avg_request_time) to (avg_request_time).
 * Also set cache: true on all product requests so repeat visits are instant.
 *
 */

Shopify.Products = (function () {
    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: 'recently-viewed-products',
        templateId: 'recently-viewed-product-template',
        layout: 'slider',
        swipe: true,
        media: 'adapt',
        onComplete: null
    };
    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;
    var cookie = {
        configuration: {
            expires: 90,
            path: '/',
            domain: window.location.hostname
        },
        name: 'shopify_recently_viewed',
        write: function (recentlyViewed) {
            jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
            localStorage.setItem(this.name, recentlyViewed.join(' '), this.configuration);
        },
        read: function () {
            var recentlyViewed = [];
            var cookieValue = jQuery.cookie(this.name);
            if (Shopify.designMode && !cookieValue) {
                cookieValue = localStorage.getItem('shopify_recently_viewed');
            }
            if (cookieValue !== null) {
                recentlyViewed = cookieValue.split(' ');
            }
            return recentlyViewed;
        },
        destroy: function () {
            jQuery.cookie(this.name, null, this.configuration);
        },
        remove: function (productHandle) {
            var recentlyViewed = this.read();
            var position = jQuery.inArray(productHandle, recentlyViewed);
            if (position !== -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
            }
        }
    };

    // Finalize the popup/widget version
    var finalize = function () {
        var items = wrapper.find('.item');
        if (items.length <= 2) $('#recently-viewed-products-list').addClass('center');
        $('#recently-viewed-products-list-2').addClass('recently-viewed-loaded');
        wrapper.show();
        if (config.onComplete) {
            try {
                config.onComplete();
            } catch (error) { }
        }
    };

    // Sequential loader used by popup template only
    var moveAlong = function (wrapperP) {
        if (productHandleQueue.length && shown < config.howManyToShow) {
            var url = window.routes.root + '/products/' + productHandleQueue[shown] + '?view=ajax_recently_viewed';
            jQuery.ajax({
                type: 'get',
                url: url,
                cache: true,
                success: function (product) {
                    wrapperP.append(product);
                    shown++;
                    moveAlong(wrapperP);
                },
                error: function () {
                    cookie.remove(productHandleQueue[shown]);
                    shown++;
                    moveAlong(wrapperP);
                }
            });
        } else {
            finalize();
        }
    };

    // Called once all parallel requests are complete
    var doAlongFinalize = function (wrapperS) {
        $('#recently-viewed-products-list-2').addClass('recently-viewed-loaded');

        if (config.layout == 'slider') {
            var productGrid = wrapperS,
                itemToShow = productGrid.data('item-to-show'),
                itemDots = productGrid.data('item-dots'),
                itemDotsMb = productGrid.data('item-dots-mb'),
                itemArrows = productGrid.data('item-arrows'),
                itemArrowsMb = productGrid.data('item-arrows-mb');

            if (productGrid.length > 0) {
                if (productGrid.not('.slick-initialized')) {
                    productGrid.slick({
                        mobileFirst: true,
                        adaptiveHeight: true,
                        vertical: false,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: itemArrowsMb,
                        dots: itemDotsMb,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            {
                                breakpoint: 1599,
                                settings: {
                                    arrows: itemArrows,
                                    dots: itemDots,
                                    get slidesToShow() {
                                        return this.slidesToShow = (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') ? itemToShow : 1;
                                    },
                                    get slidesToScroll() {
                                        return this.slidesToScroll = (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') ? itemToShow : 1;
                                    }
                                }
                            },
                            {
                                breakpoint: 1024,
                                settings: {
                                    arrows: itemArrows,
                                    dots: itemDots,
                                    get slidesToShow() {
                                        if (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') {
                                            return this.slidesToShow = (itemToShow == 5) ? itemToShow - 1 : itemToShow;
                                        }
                                        return this.slidesToShow = 1;
                                    },
                                    get slidesToScroll() {
                                        if (itemToShow !== undefined && itemToShow !== null && itemToShow !== '') {
                                            return this.slidesToScroll = (itemToShow == 5) ? itemToShow - 1 : itemToShow;
                                        }
                                        return this.slidesToScroll = 1;
                                    }
                                }
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    arrows: itemArrowsMb,
                                    dots: itemDotsMb,
                                    slidesToShow: 4,
                                    slidesToScroll: 4
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    arrows: itemArrowsMb,
                                    dots: itemDotsMb,
                                    slidesToShow: 3,
                                    slidesToScroll: 3
                                }
                            },
                            {
                                breakpoint: 320,
                                settings: {
                                    arrows: itemArrowsMb,
                                    dots: itemDotsMb,
                                    slidesToShow: 2,
                                    slidesToScroll: 2
                                }
                            }
                        ]
                    });
                }
            }

            if ($('body').hasClass('cursor-fixed__show')) {
                window.sharedFunctionsAnimation.onEnterButton();
                window.sharedFunctionsAnimation.onLeaveButton();
            }
        }

        if ($('body').hasClass('product-card-layout-08')) {
            window.sharedFunctions?.productCountdownCard();
        }

        window.sharedFunctions?.swapHoverVideoProductCard();

        if (config.onComplete) {
            try {
                config.onComplete();
            } catch (error) { }
        }
    };

    // ANB: Parallel loader - fires all requests simultaneously instead of sequentially.
    // Reduces perceived load time from (n x request_time) down to (~1 x request_time).
    var doAlong = function (wrapperS) {
        const recentlyViewed = wrapperS.parents('.halo-recently-viewed-block');

        if (!productHandleQueue.length) {
            recentlyViewed.hide();
            return;
        }

        const handles = productHandleQueue.slice(0, config.howManyToShow);
        const results = new Array(handles.length).fill(null);
        let completedCount = 0;
        let firstLoaded = false;

        // Remove skeleton loaders as soon as the first product arrives
        var removeSkeletons = function () {
            if (!firstLoaded) {
                firstLoaded = true;
                wrapperS.find('.product-item--loadingNoInfo').parents('.product').remove();
            }
        };

        // Append in original order once all requests are done
        var appendInOrder = function () {
            wrapperS.find('.product-item--loadingNoInfo').parents('.product').remove();
            results.forEach(function (html) {
                if (html) wrapperS.append(html);
            });
            doAlongFinalize(wrapperS);
        };

        handles.forEach(function (handle, index) {
            var url = window.routes.root + '/products/' + handle + '?view=ajax_section_recently_viewed';
            jQuery.ajax({
                type: 'get',
                url: url,
                cache: true,
                success: function (product) {
                    results[index] = product;
                    completedCount++;
                    removeSkeletons();
                    if (completedCount === handles.length) {
                        appendInOrder();
                    }
                },
                error: function () {
                    results[index] = null;
                    completedCount++;
                    if (completedCount === handles.length) {
                        appendInOrder();
                    }
                }
            });
        });
    };

    return {
        resizeImage: function (src, size) {
            if (size == null) {
                return src;
            }
            if (size == 'master') {
                return src.replace(/http(s)?:/, "");
            }
            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
            if (match != null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];
                return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
            } else {
                return null;
            }
        },

showRecentlyViewed: function (params) {
    var templateName = document.documentElement.getAttribute('data-template') || '';

    // ANB: Do not run recently viewed widgets on collection pages.
    // Collection templates already carry heavy product/card markup.
    if (templateName === 'collection' || document.body.classList.contains('template-collection')) {
        return;
    }

    var params = params || {};
    jQuery.extend(config, params);
    productHandleQueue = cookie.read();
    template = config.templateId;
    wrapper = jQuery('#' + config.wrapperId);

            config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);
            if (config.howManyToShow && wrapper.length) {
                if (template == 'recently-viewed-product-popup') {
                    const wrapperP = wrapper;
                    moveAlong(wrapperP);
                } else {
                    const wrapperS = wrapper;
                    doAlong(wrapperS);
                }
            }
        },

        getConfig: function () {
            return config;
        },

        clearList: function () {
            cookie.destroy();
        },

        recordRecentlyViewed: function (params) {
            var params = params || {};
            jQuery.extend(config, params);
            var recentlyViewed = cookie.read();
            if (window.location.pathname.indexOf('/products/') !== -1) {
                var splitted = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
                if (splitted == null) {
                    var productHandle = decodeURIComponent(window.location.pathname.split('/products/')[1]);
                } else {
                    var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                }
                var position = jQuery.inArray(productHandle, recentlyViewed);
                if (position === -1) {
                    recentlyViewed.unshift(productHandle);
                    recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                } else {
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }
                cookie.write(recentlyViewed);
            }
        }
    };
})();